import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Colors,
  Icon,
  Icons,
  Typography,
  createClasses,
  pxToRem,
  spacing,
} from '@kp/react-ui';

const classes = createClasses({
  root: {
    height: pxToRem(100),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing('xs'),
  },
  icon: {
    color: Colors.Neutral.iconInactive,
  },
  text: {
    color: Colors.Neutral.textInactive,
  },
});

export const KpiCardEmpty: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Icon icon={Icons.IconChart} size={24} className={classes.icon} />
      <Typography variant="bodySmall" className={classes.text}>
        {t('common.noData')}
      </Typography>
    </div>
  );
};
